import React, {useState, useEffect, useRef} from 'react'

function TodoForm(props) {
    const [input, setInput] = useState(props.edit ? props.edit.value: '');
const inputRef = useRef(null)
useEffect(()=>{
    inputRef.current.focus()
})
    const handleChange = e =>{
        setInput(e.target.value);
    };
    const handleSubmit = e =>{
        e.preventDefault();

        props.onSubmit({
            id:Math.floor(Math.random()*1000),
            text:input
        });
        setInput('');
    };
  return (
   <form className='todo-form' onSubmit={handleSubmit}>
    {props.edit ?(
        <><input placeholder='Update your item' value={input} onChange={handleChange} name='text' ref={inputRef} className='todo-input-edit'/>
        <button onClick={handleSubmit} className='todo-button edit'>Update</button></>):(
        <>
    <input type='text' placeholder='add a todo' value={input} name='text' className='todo-input' onChange={handleChange} ref={inputRef}/>
    <button className='todo-button'>Add </button>
    </>
        )}
   </form>
  )
}

export default TodoForm